import {range} from 'lodash'
import dayjs, {type Dayjs} from 'dayjs'

export const getWeek = (date: Dayjs, includeWeekend: boolean): Dayjs[] => {
  const saturday = 6
  const sunday = 0
  return range(0, 7)
    .map((daysToAdd) => dayjs(date).startOf('week').add(daysToAdd, 'days').startOf('day'))
    .filter((day) => includeWeekend || (day.day() !== sunday && day.day() !== saturday))
}
